import { render, staticRenderFns } from "./worldcup.vue?vue&type=template&id=5c793201&"
import script from "./worldcup.vue?vue&type=script&lang=js&"
export * from "./worldcup.vue?vue&type=script&lang=js&"
import style0 from "./worldcup.vue?vue&type=style&index=0&id=5c793201&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports